/* eslint-disable constructor-super */
import { Injectable } from '@angular/core';
import { PpHttpParams, PpHttpService } from '@penpencil/common';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AppUrl } from '../constants/app-url';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
    providedIn: 'root',
})
export class CoreService extends ErrorHandlerService {
    constructor(
        private _ppHttpService: PpHttpService,
        private _appUrl: AppUrl,
    ) {
        super();
    }

    permissions(query = {}): Observable<any> {
        return this._ppHttpService
            .get({
                apiPath: this._appUrl.PERMISSIONS,
                params: new PpHttpParams().appendAll(query),
            })
            .pipe(catchError(this.handleError));
    }

    getWebPreferenceData(): Observable<any> {
        return this._ppHttpService
            .get({ apiPath: 'v1/admin/web-preference' })
            .pipe(catchError(this.handleError));
    }

    postWebPreferenceData(data: any): Observable<any> {
        return this._ppHttpService
            .post(data, {
                apiPath: `v1/admin/web-preference`,
            })
            .pipe(catchError(this.handleError));
    }

    getInAppPurchase(): Observable<any> {
        return this._ppHttpService
            .get({ apiPath: 'v3/admin/in-app-purchase/apple/app' })
            .pipe(catchError(this.handleError));
    }
}
